<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Chapter One</h1>
</div>
</div>
<p class="first" style="text-align: center;">
<em style="font-size: 1em; line-height: 1.5; text-indent: 0em;"><strong>East Texas</strong></em></p>
<p class="first" style="text-align: center;">
<em><strong>1867</strong></em></p>
<p class="sectiontop">
	“Touch her, Hartly, and it’s the last earthly thing you’ll do.”</p>
<p>
	Laine Ellis issued a hard promise backed by the hammer cocking on the Colt everyone knew she carried.</p>
<p>
	Hartly didn’t turn his head. Licking his lips, he slid his hand away from the shoulder of the trembling girl standing in front of him.</p>
<p>
	“Come away, Rachel. He won’t dare do anything to you.” Laine met her sister’s panicked look with a reassuring nod. Rachel pressed herself back against the general store’s wood shelves and scraped by without touching Hartly. She clutched the calico bolt she had come to find tight to her chest as she ducked behind her older sister’s back.</p>
<p>
	“Go on up front to Mr. Larson and get your length measured. I’ll be right there.” Laine didn’t lower her gun. She didn’t look to see if Rachel obeyed her. “As for you no-account Union League trash, you so much as breathe my sister’s name and I’ll know. Bullets costing what they do, I won’t miss if I need to come looking.”Laine walked back down the aisle. When Hartly didn’t move, she holstered her gun and huffed out a breath. She hated these trips to the general store at the settlement. Measured them out in months, not weeks, when she could.</p>
<p>
	She had helped round up wild cattle in the thicket, the hottest, hardest, and dirtiest work she had ever done. The men she worked alongside were once the proud young lords of the county or sharecroppers’ sons. It no longer mattered. They were the beaten ones, forced to scratch and scheme to feed themselves and their families. Those who had any family left. They had taken and sold the cattle and given her a share for her work. She was using it to buy food and a new dress length of calico for her sister’s birthday gift.</p>
<p>
	Her long strides took her to the counter where an open sack of coffee beans rested near the grinder. She inhaled deeply, closing her eyes, sorely tempted. Then she saw the sign. “Thirty dollars a pound?” Her fingers slowly curled as her desire for coffee was crushed.</p>
<p>
	“Go on, Laine. Buy some for yourself. I don’t need the calico. You need…”</p>
<p>
	“That’s a fanciful notion. You’ve been dreaming over making that gown for nigh on a year. Anyway, I couldn’t get enough for more than a cupful. No,” she said with a shake of her head. “I made you a promise, and I never break a promise.”</p>
<p>
	Larson set a sack of rice on the counter. “That’s a mighty darn good price. Miz Ellis.” He scooped up a handful of coffee beans, let them dribble from his fingertips into the sack. “Over east in the low counties cost closer to seventy dollars a pound. Least that’s what I hear.”</p>
<p>
	“Everything costs more with the plague of riffraff since the War Between the States. Total up my order, please. I’ve a way to go.”</p>
<p>
	Laine knew to the penny how much she had spent. Caring for her younger sister and brother for the last six years had taught her to be frugal, just like every other southern woman. The dried peas and beans, sacks of cornmeal and rice along with a jug of molasses would stretch their food supply through autumn.</p>
<p>
	She added five pieces of penny candy from the big glass jar for her brother, sharing a smile with Rachel. “And don’t you be telling him or he’ll want them all before supper.”</p>
<p>
	Rachel took the paper twist of candy and tucked it beneath the string of her paper-wrapped calico. “I’ll start packing the mule.”</p>
<p>
	“No. You wait for me. I don’t trust that Hartly.” Laine bit her bottom lip. “Add a box of bullets, Mr. Larson.”</p>
<p>
	“They’re mighty dear,” he warned before he turned and reached for what she asked for. He stared at Laine. “You understand I can’t let you have this much on credit.”</p>
<p>
	“I wouldn’t expect it.”</p>
<p>
	“So you can pay for this order? Mind you, none of them Confederate Dixies.” He met Laine’s glare with his own. “Man has to be mighty careful these days. Find himself poorer than a church mouse if he don’t.”</p>
<p>
	“I can pay. Keeping polecats from my family has no price.” She hoped he understood that she was including him. Gone were the days where business was done on a word or a handclasp. The war had stolen so much. The past was too painful to think about.</p>
<p>
	Laine had already counted out the five gold pieces needed to settle her bill, but she watched him wield the stub of pencil to tally her order. Flushed with anger, she stood silent while Larson bit each and every coin, grunting with satisfaction when he was done.</p>
<p>
	Hartly had never left the store. He slunk back and watched from the shadowed corner where saddles and bridles hung from the ceiling. He caught the glint of gold and licked his lips.</p>
<p>
	Where she’d get gold money? It was scarce as fancy duds at the crossing. He’d never seen any. Didn’t see his way to getting any soon. Wasn’t right that swamp brats could lord it over him. He wasn’t gonna hurt that little gal any. He just wanted to touch her pretty white skin. And she smelled good, too. Just like them magnolias at the last plantation they’d raided. All that long hair, braided and shining like honey running over hot biscuits. She sure looked like a woman grown. Not a bit uppity like that sister of hers. Traipsing around dressed in pants and a man’s cut down jacket with that slouch hat pulled so low a man couldn’t see what she was hiding. And that belt gun with her hand never far from the butt. She knew which was the business end, never shied from using it if half the tales were true.</p>
<p>
	A chill snaked up his spine. It was her eyes that could shrivel a man where he stood. Thinking she was too good for the likes of him. He gave himself a shake. Someone needed to shut her mouth an’ teach her her place. He hitched up his pants. The right man could do the job. And there was that gold…</p>
<p class="sectiontop">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Matt Coltrane rode into the tiny settlement. Passing the crossing, he thought he would stop for a celebration drink to mark his return. One horse stood hitched to the rail in front of the saloon. He idly glanced at the brand, a habit he had picked up out west. This one did not mean anything to him. He wondered if big Bob Mitchell still owned the saloon. The sign above was so faded, he could not make out a single letter.</span></p>
<p>
	Nothing had changed in the last six years. The saloon faced the ramshackle livery stable with a cabin behind it; the general store stood apart on the other side of the road.</p>
<p>
	Under the weak effort of sunlight trying to part the clouds, the settlement took on the murky brown color of homespun. He drew rein just as two riders emerged from behind the store leading a packed mule.</p>
<p>
	Matt skimmed a knowing eye over the horses. He wouldn’t call them crowbaits, but it was a near thing. He walked his big bay to cut the path of the lead rider. He knew that rider’s seat, that proud tilt of chin, even if she was dressed like a man. His breath caught. Flashes from the past rose like quicksilver in his mind.</p>
<p>
	“Laine! Laine Ellis.”</p>
<p>
	At the mention of her name, she flinched away as if from a blow. Her hands clenched the reins, sending the horse sideling before she brought the gelding under control.</p>
<p>
	“Hello, Mr. Coltrane.”</p>
<p>
	Bewildered by Laine’s cold reaction, Matt looked behind her to the young girl.</p>
<p>
	The girl chastised, “You don’t remember me?”</p>
<p>
	The teasing note in her voice sent a grin creasing his lips.</p>
<p>
	“You’d be Miss Rachel now. No man worth the name would forget you.” He touched the brim of his black flat-crowned hat. “Pleasure to see you again. You’ve grown up to be a mighty pretty girl. Bet the boys are calling and giving your daddy …”</p>
<p>
	“Pa’s dead.”</p>
<p>
	Laine’s voice was hard and cold enough to slice through him.</p>
<p>
	“I’m real sorry to hear that. I liked and respected your pa. He was one of a few men who liked me, too.”</p>
<p>
	“I remember when you’d come to call of an evening.” Rachel smiled as if to take the sting from Laine’s stark words. “You’d be sitting in the front parlor, talking and talking. Pa said you would grow to be a fine man if they ever left you alone.”</p>
<p>
	“That’s a right kind thing to say, Miss Rachel.”</p>
<p>
	“Just the truth. Laine, you haven’t said a word of welcome to Mr. Coltrane. Can’t you say hello to him?”</p>
<p>
	“No,” she snapped without looking at either of them. “I never said goodbye.” She regretted her words the moment they left her lips. But she had been just fifteen, putting up her hair for the first time, dreaming about Matt and how she’d flirt with him.</p>
<p>
	Suddenly he was gone. Never a word in six years. Here he was, blocking her way, and her sounding crotchety like an old maid. A flush of shame colored her cheeks. Old maid wasn’t far from the truth.</p>
<p>
	Hungry for the sight of him, she looked up, pushing back the floppy brim of her slouch hat. He went away a boy and that boy was gone. A man sat confidently in the saddle of the big bay horse. Never gangly, but certainly shy with some, she wondered what had happened to him. Where had he been? Was he married? Beneath his hat he had the same unruly dark brown hair brushing his collar, eyes of hazel, a few days’ growth of dark stubble covering his angular cheeks and stubborn square chin. Her staring was rude but she didn’t care. She searched for the changes she knew were there more than appearance. Beneath the buckskin jacket and faded blue shirt his shoulders and chest were broad. All she could think of was a resting place for a weary woman.</p>
<p>
	With a slight move of his horse he leaned closer. “Looked your fill yet, Laine?” he murmured for her alone, while he swallowed the questions he burned to ask. Was she married? Widowed? That brought an ache. He’d never quite forgotten the young girl whose smile made sunshine warm him from the inside out.</p>
<p>
	Her head jerked, eyes locked on his, like grey thunderheads clashing with calm, solid oak. Neither gave way.</p>
<p>
	“What are you doing here, Matt? There’s no reason for you to come home after all this time. Pa said he sent out word about your father. We buried him, too. It’s not safe here.”</p>
<p>
	He read honest anger in both her look and voice, but there was real concern, too.</p>
<p>
	“Laine!” Rachel chided. “I can’t believe you said that to him.”</p>
<p>
	“Believe, Rachel. I meant every word, too. Listen to me, Matt. Royce Claiborne is at Cypress Bend. He’s tight with the carpetbaggers running things. And the army supports them. You can’t fight those odds. You can’t,” she finished in a defeated whisper.</p>
<p>
	Rachel turned and saw Hartly standing on the front porch of the store. She urged her horse beside Laine’s. “We need to go. That man is watching us.”</p>
<p>
	Matt set aside what Laine told him. “He bothering you?”</p>
<p>
	“No,” they denied quickly.</p>
<p>
	Matt took careful note of the slouching man. Laine had raised so many emotions and questions, sorting them would need to wait.</p>
<p>
	All but one.</p>
<p>
	“You should tell your husband.”</p>
<p>
	“Husband?” She nearly choked on the word.</p>
<p>
	“I figured by this time you’d be married with a houseful of children.”</p>
<p>
	“Well, you figured all wrong.”</p>
<p>
	Inwardly he winced at the bitterness he’d caused. Once more Rachel stepped in. “Come home with us for supper, Mr. Coltrane.”</p>
<p>
	He took account of Laine’s beautiful, weary, angry face before he answered, “It’s Matt. You call me Matt. And I’d be right pleased to accept.”</p>
<p>
	Laine didn’t bother to glare at her sister. Rachel was right to remind her of the manners their mother had instilled. She gave in graciously.</p>
<p>
	“Yes, Matt, come. Theodore will be all overexcited to hear where you’ve been.”</p>
<p>
	“The little tyke?”</p>
<p>
	“Not so little anymore. He was just a baby when you left. He thinks he’s all grown up.”</p>
<p>
	He nodded. Things had changed more than he knew if little Rachel was afraid, and Laine, he could hardly take in the changes in her. Dressing as a man, carrying a beltgun, high-strung and angry.</p>
<p>
	But she wasn’t married.</p>
<p>
	And he shouldn’t care.</p>
<p>
	With a quick glance over his shoulder, he marked the man still watching them. With a tug of his hat he swung his horse in line to follow Laine and Rachel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap202548.vue?c65a88cc